import ReactPaginate from "react-paginate";
import C from "helpers/HelpConstants";
import { HelpAbility } from "helpers/HelpAbility";
import Item from '../ItemModalEmail';

function TableModalEmail({vinculedEmail, emails = [], getEmails, totalPages, setPage, page, isSearched, setIsSearched }) {
    let myAbilities = HelpAbility();
    const { search, option, state } = isSearched;

    const handlePageClick = (data) => {
        state ? getEmails({ page: data.selected + 1, [option]: search }) : getEmails({ page: data.selected + 1 });
    };

    const resetEmails = async () => {
        setIsSearched({
            search: '',
            option: '',
            state: false
        })
        setPage(1);
        getEmails({});
    };
    return (
        <>
        <div className="mt-4">
            <div className="row mb-2">
                <div className="col d-flex align-items-end">
                    <h6>Correos registrados</h6>
                </div>
                <div className="col d-flex justify-content-end">
                    <div className="col-auto">
                        <button type="submit" className="btn btn-primary" onClick={resetEmails}>Cargar todos</button>
                    </div>
                </div>
            </div>
            <div className="table-responsive rounded-3" style={{ border: '1px solid black' }}>
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col" className="text-center">#</th>
                            <th scope="col" className="text-center">Correo</th>
                            <th scope="col" className="text-center">Número de Reportes</th>
                            {myAbilities.hasAny([C.A.CUSTOMER.LINKEMAIL]) &&
                            <th scope="col" className="text-center">Acción</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            emails.length ?
                                emails.map((email, i) => <Item
                                    key={email._id}
                                    i={i}
                                    email={email}
                                    vinculedEmail={vinculedEmail}
                                />)
                                :
                                <tr>
                                    <td colSpan="5">Sin datos</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
            <div>
                <ReactPaginate
                    previousLabel={"Anterior"}
                    nextLabel={"Siguiente"}
                    breakLabel={"..."}
                    pageCount={totalPages}
                    //Cuantas paginas quieres mostrar despues de los 3 ...
                    marginPagesDisplayed={1}
                    //En cada pagina tiene dos lados, uno izquierda y otro derecha, cuantas n paginas quieres en eso dos lados, excepto para la primera y ultima pagina que para estos cubriran n paginas pero para su dirección de ida o retorno de lado respectivamente
                    pageRangeDisplayed={2}
                    forcePage={page - 1}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination justify-content-center mt-3"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    activeClassName={"active"}
                />
            </div>
        </div>

        </>
      
    )
}

export default TableModalEmail
